import { render, staticRenderFns } from "./MedicationDetailTabs.vue?vue&type=template&id=eef8b1f8&scoped=true"
import script from "./MedicationDetailTabs.vue?vue&type=script&lang=js"
export * from "./MedicationDetailTabs.vue?vue&type=script&lang=js"
import style0 from "./MedicationDetailTabs.vue?vue&type=style&index=0&id=eef8b1f8&prod&lang=scss&scoped=true"
import style1 from "./MedicationDetailTabs.vue?vue&type=style&index=1&id=eef8b1f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef8b1f8",
  null
  
)

export default component.exports